module.exports = __webpack_public_path__ + "images/hero_background.7798c14b6d2cecfe22d94651391ee02f.jpg";